export default __webpack_public_path__ + "static/media/plus.06093943.svg";